import { faStar } from "@fortawesome/free-solid-svg-icons/faStar";

import FontAwesomeIcon from "components/FontAwesomeIcon";

import style from "./style.module.scss";

const InsightsPostHighlightedCard = ({ profile }: any) => {
  const firstName = profile?.name.split(" ")[0];

  return (
    <div className={style.top_pick_container}>
      <FontAwesomeIcon icon={faStar} className={style.icon} />
      <span> {firstName} has highlighted this Insight as a Top Pick</span>
    </div>
  );
};

export default InsightsPostHighlightedCard;
